function initHeroCarousel(root) {
  if (!root || root.dataset.heroReady === 'true') return;

  const slides = Array.from(root.querySelectorAll('[data-hero-slide]'));
  if (!slides.length) return;

  root.dataset.heroReady = 'true';

  const dots = Array.from(root.querySelectorAll('[data-hero-dot]'));
  const prevBtn = root.querySelector('[data-hero-prev]');
  const nextBtn = root.querySelector('[data-hero-next]');
  const autoplay = root.dataset.autoplay !== 'false';
  const intervalMs = (Number(root.dataset.autoplaySpeed) || 5) * 1000;

  let active = 0;
  let paused = false;
  let timer = null;

  const go = (index, restartTimer = true) => {
    active = ((index % slides.length) + slides.length) % slides.length;

    slides.forEach((slide, i) => {
      const isActive = i === active;
      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    dots.forEach((dot, i) => {
      const isActive = i === active;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-current', isActive ? 'true' : 'false');
    });

    if (restartTimer && timer) {
      window.clearInterval(timer);
      timer = window.setInterval(() => {
        if (!paused && autoplay) go(active + 1, false);
      }, intervalMs);
    }
  };

  prevBtn?.addEventListener('click', () => go(active - 1));
  nextBtn?.addEventListener('click', () => go(active + 1));
  dots.forEach((dot, index) => dot.addEventListener('click', () => go(index)));

  root.addEventListener('mouseenter', () => {
    paused = true;
  });
  root.addEventListener('mouseleave', () => {
    paused = false;
  });

  go(0, false);

  if (slides.length > 1 && autoplay) {
    timer = window.setInterval(() => {
      if (!paused) go(active + 1, false);
    }, intervalMs);
  }
}

function initHeroCarousels(scope = document) {
  scope.querySelectorAll('[data-hero-carousel]').forEach(initHeroCarousel);
}

document.addEventListener('DOMContentLoaded', () => initHeroCarousels());
document.addEventListener('shopify:section:load', (event) => initHeroCarousels(event.target));
